export default {
  turbo: "REQUEST_TYPE_TURBO",
  standard: "REQUEST_TYPE_STANDARD"
};
